const MAX_DIMENSION = 1600;
const JPEG_QUALITY = 0.82;

export interface CompressedBusinessCardImage {
  imageBase64: string;
  mimeType: 'image/jpeg';
}

function drawToJpeg(
  source: CanvasImageSource,
  width: number,
  height: number,
): CompressedBusinessCardImage {
  const scale = Math.min(1, MAX_DIMENSION / Math.max(width, height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(width * scale));
  canvas.height = Math.max(1, Math.round(height * scale));
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('canvasUnavailable');
  }
  ctx.drawImage(source, 0, 0, canvas.width, canvas.height);
  const dataUrl = canvas.toDataURL('image/jpeg', JPEG_QUALITY);
  const match = /^data:image\/jpeg;base64,(.+)$/.exec(dataUrl);
  if (!match) {
    throw new Error('encodeFailed');
  }
  return { imageBase64: match[1] ?? '', mimeType: 'image/jpeg' };
}

export function compressVideoFrame(
  video: HTMLVideoElement,
): CompressedBusinessCardImage {
  if (!video.videoWidth || !video.videoHeight) {
    throw new Error('invalidVideoFrame');
  }
  return drawToJpeg(video, video.videoWidth, video.videoHeight);
}

export function compressImageFile(
  file: File,
): Promise<CompressedBusinessCardImage> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      try {
        resolve(drawToJpeg(img, img.naturalWidth, img.naturalHeight));
      } catch (err) {
        reject(err);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('invalidImage'));
    };
    img.src = url;
  });
}
